import { normalize } from 'normalizr';

import { get } from '../utils/communications';
import { apiEndpoint } from '../utils/env';
import telemetrySchema from '../normalizr-schemas/telemetrySchema';
import { INVALIDATE_TELEMETRY, STORE_TELEMETRY } from './actionTypes';

const invalidateTelemetry = machines => ({
  type: INVALIDATE_TELEMETRY,
  payload: {
    machines,
  },
});

const storeTelemetry = telemetry => ({
  type: STORE_TELEMETRY,
  payload: {
    telemetry,
  },
});

const getTelemetry = (machines, timestamp) => (dispatch, getState) => {
  dispatch(invalidateTelemetry(machines));

  const params = { machines, timestamp };
  const organisationId = getState().currentOrganisation;
  get(`${apiEndpoint}/organisations/${organisationId}/telemetry/machine_data`, null, false, params)
    .then((telemetry) => {
      const { telemetry: telemetryData } = telemetry.data.attributes;
      const normalizedData = {};
      Object.keys(telemetryData).forEach((machineId) => {
        normalizedData[machineId] = normalize(telemetryData[machineId], telemetrySchema);
      });
      return dispatch(storeTelemetry(normalizedData));
    });
};

export { getTelemetry };



// WEBPACK FOOTER //
// ./src/actions/telemetry.js